import { Component, OnInit, ViewChild, Input, inject } from '@angular/core';
import { HomeFilter, HomeFilterLevel, HomeBanner } from 'src/app/models/client-configuration';
import { TopicService } from 'src/app/services/topic.service';
import { ConfigService } from 'src/app/services/config.service';
import { ThemeService } from 'src/app/services/theme.service';
import { ApiService } from 'src/app/services/api.service';
import { MatLegacyMenuTrigger as MatMenuTrigger } from '@angular/material/legacy-menu';
import { LocaleService } from 'src/app/services/locale.service';
import { SwiperOptions } from 'swiper/types/swiper-options';
import { FacetsFacade } from 'src/app/state/facets/facets.facade';
import { toSignal } from '@angular/core/rxjs-interop';
import type { FacetGroup } from 'src/app/state/facets/models/facets.model';
import { Router } from '@angular/router';
import { AnalyticsService } from 'src/app/_core/analytics/analytics.service';

@Component({
  selector: 'app-topic-slider',
  templateUrl: './topic-slider.component.html',
  styleUrls: ['./topic-slider.component.scss'],
})
export class TopicSliderComponent implements OnInit {
  private readonly configService = inject(ConfigService);
  private readonly facetsFacade = inject(FacetsFacade);
  private readonly router = inject(Router);
  private readonly analyticsService = inject(AnalyticsService);

  readonly facetGroups = toSignal<FacetGroup[]>(this.facetsFacade.facetGroups$);
  readonly isLoading = toSignal(this.facetsFacade.isLoading$);

  @ViewChild(MatMenuTrigger, { static: false })
  menuRef: MatMenuTrigger;

  @Input()
  topics: HomeFilter;

  subtopics: HomeFilterLevel[];

  readonly swiperConfiguration: SwiperOptions = {
    grabCursor: true,
    slidesPerView: 'auto',
    spaceBetween: 16,
    breakpoints: {
      0: {
        slidesOffsetAfter: 8,
        slidesOffsetBefore: 8,
      },
    },
    navigation: {
      enabled: !this.configService.notDesktopDevice(),
    },
  };

  homeBanner: HomeBanner;
  bannerImageUrl: string;
  textDirection: string;

  constructor(
    configService: ConfigService,
    themeService: ThemeService,
    private apiService: ApiService,
    private topicService: TopicService,
    private localeService: LocaleService
  ) {
    this.homeBanner = configService.get().homeBanner;
    this.bannerImageUrl = themeService.baseUrl + '/' + configService.get().homeBanner.imageUrl;
  }

  ngOnInit() {
    this.textDirection = this.localeService.getTextDirection();
  }

  setFacet(faceId: string) {
    this.facetsFacade.setFacet(faceId, 'home');
    this.analyticsService.searchPerformedOrigin = 'home_filter';
    this.router.navigate(['/search/facets']);
  }

  searchFacets() {
    this.router.navigate(['/search/facets'], { queryParams: { openModal: true } });
  }

  open(topic: HomeFilterLevel) {
    this.topicService.goToResults(topic);
  }

  openBannerUrl() {
    const url = this.homeBanner.targetUrl;

    if (url) {
      if (url.endsWith('type=OTK')) {
        const wnd = window.open();
        this.apiService.getExternalLoginUrl(undefined, 'OTK').subscribe((_url) => (wnd.location.href = _url));
      } else {
        window.open(url, '_blank', 'noopener');
      }
    }
  }

  showSubtopics(topic: HomeFilterLevel) {
    this.subtopics = topic.nextLevel;
  }
}
